<template>
  <div class="flow-config">
    <mw-dialog size="full" ref="dialog" class="flow-config-dialog" :title="title">
      <div class="mw-panel">
        <div class="mw-toolbar">
          <el-form :inline="true" label-width="60px">
            <el-form-item label="名称：">
              <el-input v-model='form.name'></el-input>
            </el-form-item>
            <el-form-item label="编码：">
              <el-input v-model='form.code'></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="saveForm" type="primary"><i class="fa fa-plus-square"></i>保存</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="mw-toolbar__body" style="overflow: hidden;">
          <el-col :span="12" class="__title">模板</el-col>
          <el-col :span="12" class="__title">控制</el-col>
          <el-col :span="12" class="__code">
            <mw-code-edit :value="form.template" lang="HTML" ref="formTemplate"></mw-code-edit>
          </el-col>
          <el-col :span="12" class="__code">
            <mw-code-edit :value="form.script" ref="formScript"></mw-code-edit>
          </el-col>
        </div>
      </div>
    </mw-dialog>
    <div class="__type">
      <el-form label-width="120px">
        <el-form-item label="脚本方式：">
          <el-select v-model="scriptType">
            <!--<el-option label="javascript" value="javascript" key="javascript"></el-option>-->
            <el-option label="vue" value="vue" key="vue"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="mw-panel">
      <el-tabs type="card">
        <el-tab-pane>
          <span slot="label">流程配置</span>
          <div class="mw-toolbar">
            <el-button @click="save"><i class="fa fa-plus-square"></i>保存</el-button>
          </div>
          <div class="mw-toolbar__body" style="overflow: hidden;">
            <el-col :span="12" class="__title">模板</el-col>
            <el-col :span="12" class="__title">控制</el-col>
            <el-col :span="12" class="__code">
              <mw-code-edit :value="baseTemplate" lang="HTML" ref="baseTemplate"></mw-code-edit>
            </el-col>
            <el-col :span="12" class="__code">
              <mw-code-edit :value="baseScript"  ref="baseScript"></mw-code-edit>
            </el-col>
          </div>
        </el-tab-pane>
        <el-tab-pane class="script-box">
          <span slot="label">节点配置</span>
          <toolbar-table :layout="nodeLayout" :autoLoad="true" :pagination="false" ref="nodeTable"></toolbar-table>
        </el-tab-pane>
        <el-tab-pane class="script-box">
          <span slot="label">流向配置</span>
          <toolbar-table :layout="lineLayout" :autoLoad="true" :pagination="false" ref="lineTable"></toolbar-table>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label">事件处理</span>
          <div class="mw-toolbar">
            <el-button @click="save"><i class="fa fa-plus-square"></i>保存</el-button>
          </div>
          <div class="mw-toolbar__body" style="overflow: hidden;">
            <el-col :span="24" class="__title">事件处理</el-col>
            <el-col :span="24" class="__code">
              <mw-code-edit :value="eventScript"  ref="eventScript"></mw-code-edit>
            </el-col>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      let me = this;
      return {
        title: '',
        type: '',
        scriptType: 'vue',
        nodeLayout: [],
        lineLayout: [],

        baseTemplate: '',
        baseScript: '',
        eventScript: '',

        nodeList: [],
        lineList: [],

        form: {
          id: '',
          name: '',
          code: '',
          template: '',
          script: '',
          active:'1',
        }

      };
    },
    mounted() {
      let me = this;

      me.nodeLayout = [
        [
          {
            span: 0,
            type: "menu",
            dataList: me.nodeList,
            singleSelect: true,
            columns: [
              {type: "selection"},
              {type: "index"},
              {prop: "name", label: "节点名称"},
              {prop: "code", label: "节点编码", tooltip: true}
            ]
          },
          {
            span: 10,
            type: "button",
            items: [
              {label: '新增', icon: "fa fa-plus-square", func: me.nodeAdd},
              {
                label: "编辑",
                icon: "fa fa-pencil fa-fw ",
                func: me.nodeEdit
              },
              {label: '删除', icon: "fa fa-trash-o fa-fw", func: me.nodeDelete}
            ]
          }
        ]
      ];


      me.lineLayout = [
        [
          {
            span: 0,
            type: "menu",
            dataList: me.lineList,
            singleSelect: true,
            columns: [
              {type: "selection"},
              {type: "index"},
              {prop: "name", label: "流向名称"},
              {prop: "code", label: "流向编码", tooltip: true}
            ]
          },
          {
            span: 10,
            type: "button",
            items: [
              {label: '新增', icon: "fa fa-plus-square", func: me.lineAdd},
              {
                label: "编辑",
                icon: "fa fa-pencil fa-fw ",
                func: me.lineEdit
              },
              {label: '删除', icon: "fa fa-trash-o fa-fw", func: me.lineDelete}
            ]
          }
        ]
      ];

      me.loadData();
    },

    methods: {
      loadData() {
        let me = this;
        me.mwApi.app.getFlowConfig().then((res) => {
          let data = res.result;
          if (data) {
            me.baseTemplate = data.baseTemplate;
            me.baseScript = data.baseScript;
            me.eventScript=data.eventScript;

            if (data.nodeList) {
              data.nodeList.forEach((v) => {
                if (!v.name) {
                  v.name = ''
                }
                if (!v.code) {
                  v.code = ''
                }
                if (!v.template) {
                  v.template = ''
                }
                if (!v.script) {
                  v.script = ''
                }
                me.nodeList.push(v);
              })
            }
            if (data.lineList) {
              data.lineList.forEach((v) => {
                if (!v.name) {
                  v.name = ''
                }
                if (!v.code) {
                  v.code = ''
                }
                if (!v.template) {
                  v.template = ''
                }
                if (!v.script) {
                  v.script = ''
                }
                me.lineList.push(v);
              })
            }
          }
        });
      },

      nodeAdd() {
        this.mwRef('dialog').show()
        this.title = '节点配置'
        this.type = 'node'
        this.form.id = ''
        this.form.name = ''
        this.form.code = ''
        this.form.template = ''
        this.form.script = ''
        this.form.active='1'
      },
      nodeEdit(a, b) {
        if (a.length == 0) {
          b.mwMsg('info', '请选择需要修改记录');
          return;
        }
        if (a.length > 1) {
          b.mwMsg('info', '请选择一条需要修改记录');
          return;
        }
        this.title = '节点配置'
        this.type = 'node'

        if (a[0].id) {
          this.nodeList.forEach((v) => {
            if (v.id == a[0].id) {

              this.mwUtil.apply(this.form, v)
              this.mwRef('dialog').show()
            }
          })
        }
      },
      nodeDelete(a, b) {
        if (a.length == 0) {
          b.mwMsg('info', '请选择需要删除记录')
          return
        }
        this.mwConfirm('确定删除此记录吗?').then(() => {
          this.nodeList.forEach((v, idx) => {
            if (v.id == a[0].id) {
              this.nodeList.splice(idx, 1)
            }
          })
          this.save()
        })
      },


      lineAdd() {
        this.mwRef('dialog').show()
        this.title = '流向配置'
        this.type = 'line'
        this.form.id = ''
        this.form.name = ''
        this.form.code = ''
        this.form.template = ''
        this.form.script = ''
        this.form.active='1'
      },
      lineEdit(a, b) {
        if (a.length == 0) {
          b.mwMsg('info', '请选择需要修改记录');
          return;
        }
        if (a.length > 1) {
          b.mwMsg('info', '请选择一条需要修改记录');
          return;
        }
        this.title = '流向配置'
        this.type = 'line'

        if (a[0].id) {
          this.lineList.forEach((v) => {
            if (v.id == a[0].id) {
              this.mwRef('dialog').show()
              this.mwUtil.apply(this.form, v);
            }
          })
        }
      },
      lineDelete(a, b) {
        if (a.length == 0) {
          b.mwMsg('info', '请选择需要删除记录');
          return;
        }
        this.mwConfirm('确定删除此记录吗?').then(() => {
          this.lineList.forEach((v, idx) => {
            if (v.id == a[0].id) {
              this.lineList.splice(idx, 1);
            }
          })
          this.save()
        })
      },

      saveForm() {
        let me = this;
        if (this.form.name == '') {
          this.mwMsg('info', '请输入名称');
          return;
        }
        if (this.form.code == '') {
          this.mwMsg('info', '请输入编码');
          return;
        }

        if (me.type == 'node') {
          let node;
          if (me.form.id == '') {
            me.form.id = $uuid();
          } else {
            me.nodeList.forEach((v) => {
              if (v.id == me.form.id) {
                node = v;
              }
            })
          }
          me.form.script = me.mwRef('formScript').getValue()
          me.form.template = me.mwRef('formTemplate').getValue()
          if (node) {
            me.mwUtil.apply(node, me.form)
          } else {
            node = {};
            me.mwUtil.apply(node, me.form);
            me.nodeList.unshift(node)
          }
          me.mwRef('dialog').hide();
          me.save()
        }

        if (me.type == 'line') {
          let line;
          if (me.form.id == '') {
            me.form.id = $uuid();
          } else {
            me.lineList.forEach((v) => {
              if (v.id == me.form.id) {
                line = v;
              }
            })
          }
          me.form.script = me.mwRef('formScript').getValue()
          me.form.template = me.mwRef('formTemplate').getValue()
          if (line) {
            me.mwUtil.applyCover(line, me.form)
          } else {
            line = {};
            me.mwUtil.apply(line, me.form);
            me.lineList.unshift(line)
          }
          me.mwRef('dialog').hide();
          me.save()
        }


      },
      save() {
        let me = this;
        me.mwApi.app.saveFlowConfig({
          baseTemplate: me.mwRef('baseTemplate').getValue(),
          scriptType: me.scriptType,
          baseScript: me.mwRef('baseScript').getValue(),
          eventScript: me.mwRef('eventScript').getValue(),
          nodeList: me.nodeList,
          lineList: me.lineList
        }).then((res) => {
          me.mwMsg("保存成功！");
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flow.vue